/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MAX_ITEMS_SHOW, PREFIX_AUT_ID } from 'Constants/filters';
import ItemLocation from './ItemLocation';
import { selectedLocationSelector } from 'Selectors/location';
import cssLocationGroup from './LocationGroup.scss';
import css from './LastItemGroup.scss';

const ItemToItemLocation = ({ item, onSelect }) => (<>
    <li>
        <ItemLocation item={ item } onClick={ onSelect } />
    </li>
</>);

ItemToItemLocation.propTypes = {
    item: PropTypes.object,
    onSelect: PropTypes.func
};

export const LastItemGroup = ({
    level,
    items,
    onSelect
}) => (
    <ul className={ cssLocationGroup.locationGroup } data-aut-id={ `${PREFIX_AUT_ID}${level}` }>
        { items.slice(0, MAX_ITEMS_SHOW).map(item => <ItemToItemLocation key={ item.id } item={ item } onSelect={ onSelect } />) }
        <li>
            <ul className={ css.itemsHide } >
                { items.slice(MAX_ITEMS_SHOW, items.length).map(item => <ItemToItemLocation key={ item.id } item={ item } onSelect={ onSelect } />) }
            </ul>
        </li>
    </ul>
);

LastItemGroup.propTypes = {
    items: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    level: PropTypes.number.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    selectedLocation: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
    })
};

LastItemGroup.defaultProps = {
    items: []
};

export const mapStateToProps = state => ({
    selectedLocation: selectedLocationSelector(state)
});

export default connect(mapStateToProps)(LastItemGroup);
